import type { Tab } from './index';
import { DefenseTab }           from './defense';
import { BiotechTab }           from './biotech';
import { FredTab }              from './fred';
import { SignalModelTab }       from './signal-model';
import { WireNewsTab }         from './wire-news';
import { DeFiMarketsTab }      from './defi-markets';
import { DistressTab }         from './distress';
import { ProbabilityTab }      from './probability';
import { PredictionMarketsTab }  from './prediction-markets';
import { QuantumOptimizerTab }   from './quantum-optimizer';
import { AgenticTradingTab }     from './agentic-trading';
import { WhaleTrackerTab }     from './whale-tracker';
import { BaseChartsTab }       from './base';
import { BriefTab }             from './brief';
import { BubbleChartsTab }      from './bubbles';
import { ChartsTab }            from './charts';
import { DeepResearchTab }      from './research';
import { HoldingsTab }          from './holdings';
import { InstitutionalTab }     from './institutional';
import { IPOCalendarTab }       from './ipo';
import { NewsFeedTab }          from './news';
import { NotesTab }             from './notes';
import { OptionsChainTab }      from './optionschain';
import { OptionsEducationTab }  from './options-education';
import { PerformanceTab }       from './performance';
import { PoliticalTab }         from './political';
import { RoadmapTab }           from './roadmap';
import { ScannerTab }           from './scanner';
import { SentimentTab }         from './sentiment';
import { SignalsTab }           from './signals';
import { UnicornsTab }          from './unicorns';
import { SmartMoneyTab }        from './smart-money';
import { AgentOpsTab }          from './agent-ops';

export interface NavItem { id: string; label: string; icon: string; }
export interface NavGroup { group: string; items: NavItem[]; }

export const SIDEBAR_NAV: NavGroup[] = [
  { group: 'Markets', items: [
    { id: 'brief',        label: 'Daily Brief',         icon: 'i-brief'    },
    { id: 'news',         label: 'News Feed',            icon: 'i-news'     },
    { id: 'wire-news',    label: 'Wire News',            icon: 'i-wire'     },
    { id: 'ipo',          label: 'IPO Calendar',         icon: 'i-rocket'   },
    { id: 'sentiment',    label: 'Sentiment',            icon: 'i-gauge'    },
    { id: 'fred',         label: 'Recession Indicators', icon: 'i-macro'    },
    { id: 'distress',     label: 'Distress Monitor',     icon: 'i-warn'     },
  ]},
  { group: 'Portfolio', items: [
    { id: 'tracker',      label: 'Holdings',             icon: 'i-wallet'   },
    { id: 'signal-model', label: 'Portfolio Signals',    icon: 'i-signal'   },
    { id: 'defense',      label: 'Defense Monitor',      icon: 'i-shield'   },
  ]},
  { group: 'Technicals', items: [
    { id: 'charts',          label: 'Charts + Trading',  icon: 'i-candles'  },
    { id: 'agentic-trading', label: 'Agentic Trading',   icon: 'i-signal'   },
    { id: 'optionschain',    label: 'Options Chain',     icon: 'i-chain'    },
    { id: 'performance',     label: 'Performance',       icon: 'i-trend'    },
    { id: 'agentops',        label: 'Agent Ops',         icon: 'i-trend'    },
  ]},
  { group: 'Smart Money', items: [
    { id: 'smartmoney',   label: 'Insider Buys',         icon: 'i-bank'     },
    { id: 'institutional',label: 'Institutional',        icon: 'i-bank'     },
    { id: 'political',    label: 'Political Holdings',   icon: 'i-shield'   },
    { id: 'bubbles',      label: 'Bubble Charts',        icon: 'i-bubble'   },
  ]},
  { group: 'Research', items: [
    { id: 'probability',         label: 'Probability Engine',  icon: 'i-gauge'    },
    { id: 'prediction-markets',  label: 'Prediction Markets',  icon: 'i-signal'   },
    { id: 'quantum-optimizer',   label: 'Quantum Optimizer',   icon: 'i-atom'     },
    { id: 'research',     label: 'Deep Research',        icon: 'i-research' },
    { id: 'notes',        label: 'Notes',                icon: 'i-notes'    },
    { id: 'unicorns',     label: 'Unicorns',             icon: 'i-sparkles' },
    { id: 'biotech',      label: 'Biotech',              icon: 'i-dna'      },
    { id: 'options',      label: 'Options Education',    icon: 'i-book'     },
  ]},
  { group: 'Chain', items: [
    { id: 'defi-markets',  label: 'DeFi Markets',   icon: 'i-bubble'   },
    { id: 'whale-tracker', label: 'Whale Tracker',   icon: 'i-wallet'   },
    { id: 'base',          label: 'Base Charts',     icon: 'i-candles'  },
  ]},
  { group: 'System', items: [
    { id: 'roadmap',      label: 'Roadmap',             icon: 'i-map'      },
  ]},
];

const TAB_REGISTRY = new Map<string, Tab>();
TAB_REGISTRY.set('brief',        new BriefTab());
TAB_REGISTRY.set('bubbles',      new BubbleChartsTab());
TAB_REGISTRY.set('charts',       new ChartsTab());
TAB_REGISTRY.set('ipo',          new IPOCalendarTab());
TAB_REGISTRY.set('news',         new NewsFeedTab());
TAB_REGISTRY.set('notes',        new NotesTab());
TAB_REGISTRY.set('optionschain', new OptionsChainTab());
TAB_REGISTRY.set('options',      new OptionsEducationTab());
TAB_REGISTRY.set('performance',  new PerformanceTab());
TAB_REGISTRY.set('research',     new DeepResearchTab());
TAB_REGISTRY.set('roadmap',      new RoadmapTab());
TAB_REGISTRY.set('biotech',      new BiotechTab());
TAB_REGISTRY.set('institutional',new InstitutionalTab());
TAB_REGISTRY.set('smartmoney',   new SmartMoneyTab());
TAB_REGISTRY.set('agentops',     new AgentOpsTab());
TAB_REGISTRY.set('political',    new PoliticalTab());
TAB_REGISTRY.set('scanner',      new ScannerTab());
TAB_REGISTRY.set('fred',         new FredTab());
TAB_REGISTRY.set('signal-model', new SignalModelTab());
TAB_REGISTRY.set('defense',      new DefenseTab());
TAB_REGISTRY.set('wire-news',    new WireNewsTab());
TAB_REGISTRY.set('defi-markets',  new DeFiMarketsTab());
TAB_REGISTRY.set('distress',      new DistressTab());
TAB_REGISTRY.set('probability',         new ProbabilityTab());
TAB_REGISTRY.set('prediction-markets',  new PredictionMarketsTab());
TAB_REGISTRY.set('quantum-optimizer',   new QuantumOptimizerTab());
TAB_REGISTRY.set('agentic-trading',    new AgenticTradingTab());
TAB_REGISTRY.set('whale-tracker', new WhaleTrackerTab());
TAB_REGISTRY.set('base',          new BaseChartsTab());
TAB_REGISTRY.set('sentiment',    new SentimentTab());
TAB_REGISTRY.set('signals',      new SignalsTab());
TAB_REGISTRY.set('tracker',      new HoldingsTab());
TAB_REGISTRY.set('unicorns',     new UnicornsTab());

export function getTab(id: string): Tab | undefined {
  return TAB_REGISTRY.get(id);
}

export function registerTab(tab: Tab): void {
  TAB_REGISTRY.set(tab.id, tab);
}
